import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { useSubjects } from "../SubjectContext";
import { SubjectAvatar } from "../components/SubjectSwitcher";
import AddPersonModal from "../components/AddPersonModal";
import { Button } from "../components/ui/button";
import Sidebar from "./QueryPage/Sidebar";

export default function PeoplePage() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { subjects, atLimit, refreshSubjects, setActiveSubjectId } = useSubjects();
  const [addOpen, setAddOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 p-4 md:p-8 max-w-3xl">
        <div className="flex items-center justify-between gap-3 mb-6">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">{t("subjects.managePeople")}</h1>
            <p className="text-sm text-muted-foreground mt-1">{t("subjects.manageDesc")}</p>
          </div>
          <Button
            disabled={atLimit}
            onClick={() => setAddOpen(true)}
            data-testid="people-add"
          >
            <Plus className="h-4 w-4 mr-1" />
            {t("subjects.addPerson")}
          </Button>
        </div>
        {atLimit && (
          <p className="text-sm text-amber-700 dark:text-amber-400 mb-4">
            {t("subjects.limitReached")}
          </p>
        )}
        <ul className="divide-y divide-border rounded-lg border border-border">
          {subjects.map((s) => (
            <li key={s.subject_id}>
              <Link
                to={`/people/${s.subject_id}`}
                className="flex items-center gap-3 px-4 py-3 hover:bg-muted/40"
                onClick={() => setActiveSubjectId(s.subject_id)}
              >
                <SubjectAvatar subject={s} />
                <div className="min-w-0 flex-1">
                  <div className="font-medium truncate">
                    {s.display_name}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {t(`subjects.rel.${s.relationship}`)}
                    {s.age_display ? ` · ${s.age_display}` : ""}
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
        <AddPersonModal
          open={addOpen}
          onOpenChange={setAddOpen}
          onCreated={async (created) => {
            await refreshSubjects();
            if (created?.subject_id) {
              setActiveSubjectId(created.subject_id);
              navigate(`/people/${created.subject_id}`);
            }
          }}
        />
      </main>
    </div>
  );
}
